// extracted by mini-css-extract-plugin
export default {"rule-benefit":"rules_benefit_rule-benefit__JEa3s","Mui-focused":"rules_benefit_Mui-focused__BBV7J","label":"rules_benefit_label__V7aIb"};